import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "stickTo", "textAlign"];
import React, { useContext } from 'react';
import { Flex } from '../../../Flex';
import { ColumnTextAlign } from '../../Table.decl';
import { TableRootContext } from '../TableRoot/context';
import { StyledTableData } from './styled';
export var TableData = function TableData(_ref) {
  var children = _ref.children,
      stickTo = _ref.stickTo,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? ColumnTextAlign.Left : _ref$textAlign,
      otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useContext = useContext(TableRootContext),
      scrollAtEnd = _useContext.scrollAtEnd;

  var stylingProps = _extends({}, stickTo ? {
    stickTo: stickTo,
    stuck: scrollAtEnd[stickTo]
  } : {});

  return /*#__PURE__*/React.createElement(StyledTableData, _extends({}, stylingProps, otherProps), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: textAlign
  }, children));
};